import apiClient from "../api";

export const loginUser = (data) => apiClient.post("/user/login", data);
export const registerUser = (data) => apiClient.post("/user/register", data);
export const createProject = (data) => apiClient.post("/user/projects", data);
export const projects = (data) =>
  apiClient.get("/user/projects", {
    params: data,
  });
export const projectById = (id) => apiClient.get(`/user/projects/${id}`);
/* for admin edit  */
export const updateProject = (id, data) => {
  return apiClient.put(`/user/projects/${id}`, data);
};
/* for user edit  */
export const editProject = (id, data) =>
  apiClient.put(`/user/projects/edit/${id}`, data);

export const verifyOtp = (data) => apiClient.post("/user/verify-otp", data);
export const resendOtp = (data) => apiClient.post("/user/resend-otp", data);
export const forgotPassword = (data) =>
  apiClient.post("/user/forgot-password", data);
export const resetPassword = (data) =>
  apiClient.post("/user/reset-password", data);

export const viewProject = (id, token) =>
  apiClient.get(`/user/projects/proposal/${id}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

export const acceptProject = (id, data) =>
  apiClient.post(`/user/projects/accept/${id}`, data);

export const uploadProjectFiles = (id, data) =>
  apiClient.post(`/user/projects/${id}/files`, data);

export const getProjectFiles = (id, params) =>
  apiClient.get(`/user/projects/${id}/files`, {
    params,
  });
export const updateDraftStatus = (id, data) =>
  apiClient.put(`/user/projects/${id}/draft`, data);

export const getSettings = () => {
  return apiClient.get(`/user/settings`);
};

export const verifySetUp = (token) => {
  return apiClient.get(`/user/verify-set-up/${token}`);
};

export const setUpPassword = (token, data) => {
  return apiClient.put(`/user/set-up-password/${token}`, data);
};
export const updateUser = (id, data) => {
  return apiClient.put(`/user/${id}`, data);
};

export const getServicesApi = (projectId, planId) => {
  return apiClient.get(`/user/projects/services`, {
    params: {
      projectId,
      planId,
    },
  });
};

export const addOrUpdateService = (data) => {
  return apiClient.post(`/user/projects/services`, data);
};

export const deleteService = (id, data) => {
  return apiClient.delete(`/user/projects/services/${id}`, data);
};

export const sendProposalOtp = (id, data) => {
  return apiClient.post(`/user/projects/proposal/${id}/send-otp`);
};
export const verifyProposalOtp = (id, data) => {
  return apiClient.post(`/user/projects/proposal/${id}/verify-otp`, data);
};
